import { TipoInmuebleService } from './../../services/tipo-inmueble.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizationService } from '../../services/localization.service';
import { Location } from '@angular/common';
import { AuthService } from '../../services/auth.service';
import { MatDialogRef } from '@angular/material';


@Component({
  selector: 'app-tipo-inmueble-edit',
  templateUrl: './tipo-inmueble-edit.component.html',
  styleUrls: ['./tipo-inmueble-edit.component.scss']
})
export class TipoInmuebleEditComponent implements OnInit {

  editForm: FormGroup;
  title = 'Crear';
  isNewElement: boolean;
  isModal: boolean;
  id: string;
  errorMessage: any;

  options: any = {
    format: 'DD/MM/YYYY HH:mm z'
  };

  constructor(private _fb: FormBuilder, private _avRoute: ActivatedRoute, private localization: LocalizationService,
    private _TipoInmuebleService: TipoInmuebleService, private _authService: AuthService, private _router: Router,
    public dialogRef: MatDialogRef<TipoInmuebleEditComponent>, private _location: Location) {

      if (this._avRoute.snapshot.params['id']) {
        this.id = this._avRoute.snapshot.params['id'];
      }

      this.editForm = this._fb.group({
        id: ['', Validators.required],
        nombre: ['', Validators.required],
        disabled: [false]
      });

  }

  ngOnInit() {
    if (this.id != '0') {
      this.isNewElement = false;
      this.title = 'Editar';
      this._TipoInmuebleService.getTipoInmuebleByID(this.id)
        .subscribe(resp => {
          this.editForm.setValue(resp);
        }
          , error => {
            this.errorMessage = error;
            console.log(error);
          });
    } else {
      this.isNewElement = true;
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  cancel() {
    if (!this.isModal) {
      this._location.back();
    } else {
      this.closeDialog();
    }
  }

  save() {
    if (!this.editForm.valid) {
      return;
    }

    if (this.isNewElement) {
      this._TipoInmuebleService.createTipoInmueble(this.editForm.getRawValue())
        .subscribe((data) => {
          if (!this.isModal) {
            this._location.back();
          } else {
            this.closeDialog();
          }
        }, error => this.errorMessage = error);
    } else {
      this._TipoInmuebleService.updateTipoInmueble(this.editForm.getRawValue())
        .subscribe((data) => {
          if (!this.isModal) {
            this._location.back();
          } else {
            this.closeDialog();
          }
        }, error => this.errorMessage = error)
    }
  }

}
